import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { PackageHelperComponent } from './package-helper.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ],
  exports: [
    PackageHelperComponent
  ],
  providers: [
  ],
  declarations: [
    PackageHelperComponent
  ]
})
export class PackageHelperModule { }
